import translationsPt from '#src/i18n/pt.json'
import translationsEn from '#src/i18n/en.json'

import { createI18n } from 'vue-i18n'
import axios from 'axios'
import dayjs from 'dayjs'

import { updatePreferredLocale } from '#src/api/profile'

/**
 * Sets the requested language
 *
 * @param {string} lang Language to set (eg. 'pt', 'en')
 * @param {object} auth Authentication data provided by the auth mixin (this.$auth)
 */
export async function setLocale (lang, auth) {
  // If the same language
  if (i18n.locale === lang) {
    return setI18nLanguage(lang)
  }

  // Update lang in profile
  if (auth?.isLogged()) {
    await updatePreferredLocale({ locale: lang })
  }

  return setI18nLanguage(lang)
}

/**
 * Does all required work to set the language, function does not handle translations async load
 *
 * @param {string} lang Language to set (eg. 'pt', 'en')
 */
function setI18nLanguage (lang) {
  i18n.global.locale.value = lang
  dayjs.locale(lang)
  window.localStorage.setItem('language', lang)
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

/** Vue-i18n plugin instance */
const i18n = createI18n({
  silentFallbackWarn: true,
  // default locale
  locale: 'pt',
  allowComposition: true,
  globalInjection: true,
  messages: {
    pt: translationsPt,
    en: translationsEn
  },
  silentTranslationWarn: true
})

// Set starting language
let language = window.localStorage.getItem('language') || window.navigator.language.split('-')[0]
language = language === 'pt' ? 'pt' : 'en'
setLocale(language)

export default i18n
